import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.4.195C10.1 0 9.6.098 9.3.293L4.6 4.008H1c-.6 0-1 .39-1 .977v5.866c0 .586.4.978 1 .978h3.6l4.7 3.714c.2.098.4.196.6.196.1 0 .3 0 .4-.098.3-.195.6-.489.6-.88V1.075c.1-.39-.1-.684-.5-.88M9 12.708l-3.4-2.64c-.2-.097-.4-.195-.6-.195H2v-3.91h3c.2 0 .4-.098.6-.196L9 3.128zm4.8-8.896a.93.93 0 0 0 0 1.37c1.6 1.563 1.6 4.007 0 5.571a.93.93 0 0 0 0 1.37c.2.194.5.292.7.292s.5-.098.7-.293c2.3-2.249 2.3-5.963 0-8.31-.3-.39-1-.39-1.4 0m5-3.519a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37 8.65 8.65 0 0 1 0 12.414.93.93 0 0 0 0 1.37c.2.194.5.292.7.292s.5-.098.7-.293c4.3-4.106 4.3-10.95 0-15.153"
    }, null, -1)
  ]))]))
}
export default { render: render }